module.exports = __webpack_public_path__ + "img/icon-play.b5826bc5.svg";